import React, { Component } from 'react';
import wrapper from './blockDecorator';
import RenderBlocks from '~/components/editor/RenderBlocks';
import Tabs from '~/components/editor/Tabs';
import BlockCTA from '~/components/editor/BlockCTA';
import BlockCTAFreeEvents from '~/components/editor/BlockCTAFreeEvents';
import classNames from 'classnames';

class Block extends React.Component {
  countTextColor(background) {
    return background === '#C5C5C5' || background === '#FFF' ? '#000' : '#FFF';
  }

  render() {
    const { block, onAddChild, onChildAction } = this.props;

    let isSingle = block.content.group_items?.length === 1;
    if (!isSingle) {
      isSingle = block.content.group_image_columns?.length === 1;
    }

    switch (block.type) {
    case 'heading_level_1':
      return <h2 className="h1">{block.content.group_heading[0].title}</h2>;

    case 'heading_level_2':
      return <h2 className="h2">{block.content.group_heading[0].title}</h2>;

    case 'heading_level_3':
      return <h3 className="h3">{block.content.group_heading[0].title}</h3>;

    case 'html_editor':
    case 'html_ol':
    case 'html_ul':
    case 'table':

      return (
        <div
          className="clean-html editor"
          dangerouslySetInnerHTML={{
            __html: block.content.group_html[0].text,
          }}
        />
      );

    case 'table-new':
      const tableRowsBody = block.content.group_html[0].text.map((row, y) => {
        if (y === 0) {
          const headCells = row.map((cell, x) => {
            return <th key={`cell-${y}-${x}`}>{cell}</th>;
          });
          return <tr key={`row-${y}`}>{headCells}</tr>;
        } else {
          const bodyCells = row.map((cell, x) => {
            return <td key={`cell-${y}-${x}`}>{cell}</td>;
          });
          return <tr key={`row-${y}`}>{bodyCells}</tr>;
        }
      });

      const tableRowsHead = tableRowsBody.splice(0, 1);

      return (
        <div className="clean-html editor">
          <table>
            <thead>{tableRowsHead}</thead>
            <tbody>{tableRowsBody}</tbody>
          </table>
        </div>
      );

    case 'html_editor_columns':
    case 'html_ol_columns':
    case 'html_ul_columns':
      return (
        <React.Fragment>
          <div className="col-6">
            <div
              className="clean-html editor"
              dangerouslySetInnerHTML={{
                __html: block.content.group_html[0].text,
              }}
            />
          </div>
          <div className="col-6">
            <div
              className="clean-html editor"
              dangerouslySetInnerHTML={{
                __html: block.content.group_html[1].text,
              }}
            />
          </div>
        </React.Fragment>
      );

    case 'big_text':
      return (
        <p className="big-text">{block.content.group_content[0].text}</p>
      );

    case 'diagrams':
      const diagrams = block.content.group_items.map((b, index) => {
        return (
          <div key={`${block.type}_${block.sort}_${index}`} className="col-6">
            <div className="diagram">
              <div
                className="diagram__circles"
                data-percent={b.value}
                data-indent={b.offset}
              ></div>
              <div
                className="clean-html editor"
                dangerouslySetInnerHTML={{ __html: b.text }}
              />
            </div>
          </div>
        );
      });

      return <React.Fragment>{diagrams}</React.Fragment>;

    case 'cta':
    {
      // Wrapper need for anonymous users and target for react render in static-html
      const ctaDisc = block.content.group_content[0].reference;
      if (!block?.content?.group_content[0]?.btn_text) {
        const { items } = block.forms[0];
        const duration = block.forms[0].items.find(item => item.name === 'duration');
        duration.size = 'half';
        block.content.group_content[0].btn_text = 'Расписание и цены';
        block.forms[0].items = [
          duration,
          {
            name: 'btn_text',
            type: 'text',
            size: 'half',
            label: 'Текст кнопки',
          },
          ...items.slice(1, items.length),
        ];
      }
      return (
        <div
          className="cta__wrapper"
          data-disciplines={ctaDisc ? ctaDisc.join('/') : ''}
          data-duration={block.content.group_content[0].duration}
          data-btn-text={block.content.group_content[0].btn_text}
        >
          <BlockCTA
            disciplines={ctaDisc || ''}
            duration={block.content.group_content[0].duration}
            btnText={block.content.group_content[0].btn_text}
          />
        </div>
      );
    }

    case 'ctaImage':
    {
      const buttonsStr = block.content.group_content.map((item, index) => {
        const refStr = `[${item.reference.map(item => `"${item}"`)}]`;
        const btnClassStr = !index
          ? 'btn btn--primary cta-image__btn'
          : 'btn btn--outline-white cta-image__btn';
        return (
          <div
            className="checkin-mini__wrap"
            key={`${block.type}_${block.sort}_${index}`}
          >
            <a className={btnClassStr} href={item.btn_url} data-code={refStr}>
              {item.btn_text}
            </a>
            <div className="event-checkin-react" data-code={refStr}></div>
          </div>
        );
      });

      return (
        <section className="cta-image__wrapper">
          <div className="cta-image__content">
            <header className="cta-image__header">
              {block.content?.group_header[0]?.header}
            </header>
            <div className="checkin-mini checkin-mini--btns cta-image__buttons">
              {buttonsStr}
            </div>
          </div>
          <div className="cta-image__photo-wrapper">
            <div
              className="cta-image__photo"
              style={{
                backgroundImage: `url(${block.content?.group_image[0]?.image}`,
              }}
            ></div>
          </div>
        </section>
      );
    }

    case 'ctaFreeEvents':
    {
      const ctaDisc = block.content.group_content[0]?.reference;
      const ctaImage = block.content.group_image[0]?.image;
      const title = block.content.group_header[0]?.header;
      return (
        <div
          className="cta-free__wrapper"
          data-disciplines={ctaDisc ? ctaDisc.join('/') : ''}
          data-image={ctaImage}
          data-title={title}
        >
          <BlockCTAFreeEvents disciplines={ctaDisc || ''} image={ctaImage} title={title}/>
        </div>
      );
    }

    case 'price':
      return (
        <div className="price">
          <div className="price__descr">
            <div className="price__red-block">
              <div className="price__price">
                {block.content.group_left[0].price_old && <div className={classNames('price__price_old')}>
                  <span>{block.content.group_left[0].price_old}</span>
                </div>}
                <span>{block.content.group_left[0].price}</span>
                {block.content.group_left[0].price_quote && <span className="price__price_star">*</span>}
              </div>
              <div className="price__text txt">
                {block.content.group_left[0].price_text}
              </div>
            </div>

            <div className="price__note txt--sm">
              {block.content.group_left[0].price_quote &&
              <div className="price__note_text">
                <span className="price__note_star">*</span>
                {block.content.group_left[0].price_quote}
              </div>}
            </div>
          </div>
          <div className="price__list">
            <div
              className="clean-html editor"
              dangerouslySetInnerHTML={{
                __html: block.content.group_right[0].text,
              }}
            />
          </div>
        </div>
      );

    case 'image':
      return <img className="img" src={block.content.group_image[0].image}/>;

    case 'image-link':
      return (
        <a href={block.content.group_image[0].link_url}>
          <img className="img" src={block.content.group_image[0].image}/>
        </a>
      );

    case 'spoiler':
      const spoilers = block.content.group_spoiler.map((b, index) => {
        return (
          <div key={`spoiler_${index}`} className="simple-spoiler is-active">
            <a className="simple-spoiler__head">{b.title}</a>
            <div className="simple-spoiler__body">
              {b.children && (
                <RenderBlocks
                  data={b.children}
                  children={true}
                  onBlockAction={(type, sort, action) =>
                    onChildAction(type, sort, action, {
                      block: block,
                      group: 'group_spoiler',
                      indexItem: index,
                    })
                  }
                />
              )}
              <button
                className="editor__btn-addblock editor__btn-addblock--red for-admin"
                onClick={() => onAddChild('group_spoiler', index)}
              >
                Добавить блок
              </button>
            </div>
          </div>
        );
      });
      return <div className="simple-spoilers">{spoilers}</div>;

    case 'tabs':
      return (
        <Tabs
          block={block}
          onAddChild={index => onAddChild('group_tabs', index)}
          onChildAction={(type, sort, action, index) =>
            onChildAction(type, sort, action, {
              block: block,
              group: 'group_tabs',
              indexItem: index,
            })
          }
        />
      );

    case 'popup':
      const popup = block.content.group_popup.map((b, index) => {
        return (
          <div
            key={`popup_${index}`}
            id={`popup-${b.idkey}`}
            className="simple-popup"
          >
            <button
              type="button"
              className="popup__close"
              style={{ top: 'auto' }}
            />
            <a className="simple-popup__head">{b.title}</a>
            <div className="simple-popup__body">
              {b.children && (
                <RenderBlocks
                  data={b.children}
                  children={true}
                  onBlockAction={(type, sort, action) =>
                    onChildAction(type, sort, action, {
                      block: block,
                      group: 'group_popup',
                      indexItem: index,
                    })
                  }
                />
              )}
              <button
                className="editor__btn-addblock editor__btn-addblock--red for-admin"
                onClick={() => onAddChild('group_popup', index)}
              >
                Добавить блок
              </button>
            </div>
          </div>
        );
      });
      return <div className="simple-popups">{popup}</div>;

    case 'promo':
      let promoBtn = null;
      if (
        block.content.promo_btn &&
        block.content.promo_btn[0] &&
        block.content.promo_btn[0].link_url &&
        block.content.promo_btn[0].link_text
      )
      {
        promoBtn = (
          <a
            className="btn btn--primary"
            href={block.content.promo_btn[0].link_url}
          >
            {block.content.promo_btn[0].link_text}
          </a>
        );
      }
      let promoImage = null;
      if (block.content.promo_desc[0].image) {
        promoImage = (
          <div className="collage__logos">
            <div className="collage__logo">
              <img src={block.content.promo_desc[0].image}/>
            </div>
          </div>
        );
      }
      return (
        <div className="collage">
          <div
            className="collage__image"
            style={{
              backgroundImage: `url('${block.content.promo_image[0].image}')`,
            }}
          >
            <div className="collage__descr txt-accent">
              <span>{block.content.promo_image[0].title}</span>
            </div>
          </div>
          <div className="collage__blocks">
            <div className="collage__red-block"></div>
            <div className="collage__black-block">
              {promoImage}
              <div
                dangerouslySetInnerHTML={{
                  __html: block.content.promo_desc[0].text,
                }}
                className="clean-html editor"
              />
              {promoBtn}
            </div>
          </div>
        </div>
      );

    case 'diplom':
      const diplom_btn = block.content.group_desc[0].link_url ? (
        <a
          className="btn btn--primary"
          href={block.content.group_desc[0].link_url}
        >
          {block.content.group_desc[0].link_text}
        </a>
      ) : null;
      return (
        <div className="diplom-block">
          <div className="diplom-block__image">
            <img src={block.content.group_images[0].image}/>
          </div>
          <div className="diplom-block__text">
            <div
              dangerouslySetInnerHTML={{
                __html: block.content.group_desc[0].text,
              }}
              className="clean-html editor"
            />
            {diplom_btn}
          </div>
        </div>
      );

    case 'buttons':
      const buttons_mainbtn = block.content.group_buttons[0].btn_main_url ? (
        <a
          className="btn btn--primary"
          href={block.content.group_buttons[0].btn_main_url}
        >
          {block.content.group_buttons[0].btn_main_text}
        </a>
      ) : null;
      const buttons_secondbtn = block.content.group_buttons[0]
        .btn_second_url ? (
        <a
          className="btn btn--outline"
          href={block.content.group_buttons[0].btn_second_url}
        >
          {block.content.group_buttons[0].btn_second_text}
        </a>
      ) : null;
      return (
        <div className="buttons">
          {buttons_mainbtn}
          {buttons_secondbtn}
        </div>
      );

    case 'video':
    {
      const URL = block.content.group_video[0].video.replace(
        'youtu.be/',
        'youtube.com/watch?v=',
      );
      return (
        <a className="video" href={URL}>
          <img src={block.content.group_video[0].video_prev}/>
        </a>
      );
    }

    case 'line_numbers':
      const line_numbers_first = block.content.group_items.map((b, index) => {
        const textColor = this.countTextColor(b.color);
        return (
          <div
            key={`${block.type}_group_items_${index}`}
            className="accord-top__block"
            style={{ backgroundColor: b.color }}
          >
            <p style={{ color: textColor }} className="accord-top__title">
              {b.number}
            </p>
            <p style={{ color: textColor }} className="title title--sm">
              {b.title}
            </p>
          </div>
        );
      });
      const line_numbers_second = block.content.group_subitems.map(
        (b, index) => {
          const textColor = this.countTextColor(b.color);
          return (
            <div
              style={{ backgroundColor: b.color }}
              key={`${block.type}_group_subitems_${index}`}
              className="accord-bottom__block"
            >
              <p style={{ color: textColor }} className="txt">
                {b.title}
              </p>
            </div>
          );
        },
      );
      return (
        <div className="accord">
          <div className="accord__wrap">
            <div className="accord__content">
              <div className="accord__top accord-top">
                {line_numbers_first}
              </div>
              <div className="accord__bottom accord-bottom">
                {line_numbers_second}
              </div>
            </div>
          </div>
        </div>
      );

    case 'line_icons':
      const line_icons_first = block.content.group_items.map((b, index) => {
        const textColor = this.countTextColor(b.color);
        return (
          <div
            key={`${block.type}_group_items_${index}`}
            className="accord-top__block"
            style={{ backgroundColor: b.color }}
          >
            <div className="accord-top__wrap">
              <div
                style={{
                  width: '52px',
                  height: '52px',
                  background: `url("/static/img/constructor/icons/white/${b.icon}.svg") no-repeat center center`,
                }}
                className="accord-top__img"
              />
            </div>
            <p style={{ color: textColor }} className="title title--sm">
              {b.title}
            </p>
          </div>
        );
      });
      const line_icons_second = block.content.group_subitems.map(
        (b, index) => {
          const textColor = this.countTextColor(b.color);
          return (
            <div
              key={`${block.type}_group_subitems_${index}`}
              className="accord-bottom__block"
              style={{ backgroundColor: b.color }}
            >
              <p style={{ color: textColor }} className="txt">
                {b.title}
              </p>
            </div>
          );
        },
      );
      return (
        <div className="accord">
          <div className="accord__wrap">
            <div className="accord__content">
              <div className="accord__top accord-top">{line_icons_first}</div>
              <div className="accord__bottom accord-bottom">
                {line_icons_second}
              </div>
            </div>
          </div>
        </div>
      );

    case 'line_images':
      const line_images_first = block.content.group_items.map((b, index) => {
        return (
          <div
            key={`${block.type}_group_items_${index}`}
            className="accord-top__block"
            style={{ backgroundColor: b.color }}
          >
            <img className="accord-top__img" src={b.icon}/>
          </div>
        );
      });
      const line_images_second = block.content.group_subitems.map(
        (b, index) => {
          const textColor = this.countTextColor(b.color);
          return (
            <div
              key={`${block.type}_group_subitems_${index}`}
              className="accord-bottom__block"
              style={{ backgroundColor: b.color }}
            >
              <p style={{ color: textColor }} className="txt">
                {b.title}
              </p>
            </div>
          );
        },
      );
      return (
        <div className="accord">
          <div className="accord__wrap">
            <div className="accord__content">
              <div className="accord__top accord-top">
                {line_images_first}
              </div>
              <div className="accord__bottom accord-bottom">
                {line_images_second}
              </div>
            </div>
          </div>
        </div>
      );

    case 'columns_icons':
      const columns_icons = block.content.group_items.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="simple-icons__item"
          >
            <img
              className="icon"
              src={`/static/img/constructor/icons/red/${b.icon}.svg`}
            />
            <p className="simple-icons__title">{b.title}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: b.text,
              }}
              className="clean-html editor"
            />
          </div>
        );
      });

      return (
        <div
          className={`simple-icons simple-icons--length-${columns_icons.length}`}
        >
          {columns_icons}
        </div>
      );

    case 'files':
      const files = block.content.group_files.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="simple-icons__item"
          >
            <a href={b.file} target="_blank">
              <img
                className="icon"
                src="/static/img/constructor/icons/red/Folder Open.svg"
              />
            </a>
            <a href={b.file} target="_blank" className="simple-icons__title">
              {b.title}
            </a>
            <div
              dangerouslySetInnerHTML={{
                __html: b.desc,
              }}
              className="clean-html editor"
            />
          </div>
        );
      });

      return (
        <div className={`simple-icons simple-icons--length-${files.length}`}>
          {files}
        </div>
      );

    case 'columns_numbers':
      const columns_numbers = block.content.group_items.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="simple-icons__item"
          >
            <div className="icon-text">{b.number}</div>
            <p className="simple-icons__title">{b.title}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: b.text,
              }}
              className="clean-html editor"
            />
          </div>
        );
      });

      return (
        <div
          className={`simple-icons simple-icons--length-${columns_numbers.length}`}
        >
          {columns_numbers}
        </div>
      );

    case 'columns_words':
      const columns_words = block.content.group_items.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="simple-icons__item"
          >
            <div className="icon-text">{b.number}</div>
            <p className="simple-icons__title">{b.title}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: b.text,
              }}
              className="clean-html editor"
            />
          </div>
        );
      });

      return (
        <div
          className={`simple-icons simple-icons--length-${columns_words.length}`}
        >
          {columns_words}
        </div>
      );

    case 'columns_optional':
      const columns_optional = block.content.group_items.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="simple-icons__item"
          >
            <div className="icon-text">{b.number}</div>
            <p className="simple-icons__title">{b.title}</p>
            <div
              dangerouslySetInnerHTML={{
                __html: b.text,
              }}
              className="clean-html editor"
            />
          </div>
        );
      });

      return (
        <div
          className={`simple-icons simple-icons--length-${columns_optional.length}`}
        >
          {columns_optional}
        </div>
      );

    case 'columns_red_icons':
      const columns_red_icons = block.content.group_items.map((b, index) => {
        return (
          <li
            key={`${block.type}_${block.sort}_${index}`}
            className={classNames('course-content__item', { 'single': isSingle })}
          >
            <div className="course-content__pagination">
              <div
                className="img"
                style={{
                  width: '40px',
                  height: '40px',
                  background: `url("/static/img/constructor/icons/red/${b.icon}.svg") no-repeat center center`,
                }}
              />
            </div>
            <div className="course-content__info">
              <div
                dangerouslySetInnerHTML={{
                  __html: b.text,
                }}
                className="clean-html editor"
              />
            </div>
          </li>
        );
      });

      return <ul className="course-content__list">{columns_red_icons}</ul>;

    case 'columns_red_words':
      const columns_red_words = block.content.group_items.map((b, index) => {
        return (
          <li
            key={`${block.type}_${block.sort}_${index}`}
            className={classNames('course-content__item', { 'single': isSingle })}
          >
            <div className="course-content__pagination">
              <span>{b.icon}</span>
            </div>
            <div className="course-content__info">
              <div
                dangerouslySetInnerHTML={{
                  __html: b.text,
                }}
                className="clean-html editor"
              />
            </div>
          </li>
        );
      });

      return <ul className="course-content__list">{columns_red_words}</ul>;

    case 'columns_red_numbers':
      const columns_red_numbers = block.content.group_items.map(
        (b, index) => {
          return (
            <li
              key={`${block.type}_${block.sort}_${index}`}
              className={classNames('course-content__item', { 'single': isSingle })}
            >
              <div className="course-content__pagination">
                <span>{b.icon}</span>
              </div>
              <div
                dangerouslySetInnerHTML={{
                  __html: b.text,
                }}
                className="clean-html editor"
              />
            </li>
          );
        },
      );

      return <ul className="course-content__list">{columns_red_numbers}</ul>;

    case 'columns_red_optional':
      const columns_red_optional = block.content.group_items.map(
        (b, index) => {
          return (
            <li
              key={`${block.type}_${block.sort}_${index}`}
              className={classNames('course-content__item', { 'single': isSingle })}
            >
              <div className="course-content__pagination">
                <span>{b.icon}</span>
              </div>
              <div className="course-content__info">
                <div
                  dangerouslySetInnerHTML={{
                    __html: b.text,
                  }}
                  className="clean-html editor"
                />
              </div>
            </li>
          );
        },
      );

      return <ul className="course-content__list">{columns_red_optional}</ul>;

    case 'columns_images':
      const columns_images = block.content.group_image_columns.map(
        (b, index) => {
          return (
            <div
              key={`${block.type}_${block.sort}_${index}`}
              // className={classNames("course-content__item", {"single": isSingle})}
              className={classNames('list-descr__item', { 'single': isSingle })}
            >
              <div
                className="list-descr__img"
                style={{ backgroundImage: `url('${b.image}')` }}
              >
                <div className="list-descr__heading txt-accent">
                  <span>{b.title}</span>
                </div>
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: b.text }}
                className="clean-html editor"
              />
            </div>
          );
        },
      );

      return <div className="list-descr">{columns_images}</div>;

    case 'steps':
      const countHide = block.content.group_count
        ? parseInt(block.content.group_count[0].count_hide)
        : 10;

      const steps = block.content.group_items.map((b, index) => {
        const classes = ['course-content__item'];
        if (index + 1 > countHide)
          classes.push('course-content__item--hidden');
        if (isSingle)
          classes.push('single');

        return (
          <li
            key={`${block.type}_${block.sort}_${index}`}
            className={classes.join(' ')}
          >
            <div className="course-content__pagination">
              <span>{b.marker}</span>
            </div>
            <div className="course-content__info">
              <div
                dangerouslySetInnerHTML={{
                  __html: b.text,
                }}
                className="clean-html editor"
              />
            </div>
          </li>
        );
      });

      let btnShowAll = null;
      if (steps.length > countHide) {
        btnShowAll = (
          <div className="buttons">
            <a href="#showmore" className="btn btn--outline">
              Смотреть все
            </a>
          </div>
        );
      }

      return (
        <React.Fragment>
          <ul className="course-content__list course-content--table">
            {steps}
          </ul>
          {btnShowAll}
        </React.Fragment>
      );

    case 'key_phrase':
      return (
        <div className="clean-html editor">
          <blockquote>{block.content.group_phrase[0].text}</blockquote>
        </div>
      );

    case 'quote':
      return (
        <div className="clean-html editor">
          <blockquote>
            {block.content.group_quote[0].text}
            <div className="commentary__author">
              <p className="title">{block.content.group_quote[0].author}</p>
              <p className="txt--sm">
                {block.content.group_quote[0].author_pos}
              </p>
            </div>
          </blockquote>
        </div>
      );

    case 'hr':
      return <hr/>;

    case 'margin':
      return <div className="margin"/>;

    case 'margin-big':
      return <div className="margin--big"/>;

    case 'slider_images':
      const slider_images = block.content.group_items.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="cur-news-slider__item contacts-slider__item swiper-slide"
            style={{ backgroundImage: `url(${b.image})` }}
          />
        );
      });

      return (
        <div className="cur-news-slider contacts-slider swiper-container">
          <div className="contacts-slider__wrap swiper-wrapper">
            {slider_images}
          </div>
          <div className="contacts-footer">
            <div className="contacts-pagination swiper-pagination"></div>
            <div className="contacts-nav-wrapper">
              <div className="swiper-button-next"></div>
              <div className="swiper-button-prev"></div>
            </div>
          </div>
        </div>
      );

    case 'slider_images_vertical':
      const slider_images_vertical = block.content.group_items.map(
        (b, index) => {
          return (
            <div
              key={`${block.type}_${block.sort}_${index}`}
              className="cur-news-slider__item contacts-slider__item swiper-slide cur-news-slider__item--vertical"
              style={{ backgroundImage: `url(${b.image})` }}
            />
          );
        },
      );

      return (
        <div className="cur-news-slider contacts-slider swiper-container">
          <div className="contacts-slider__wrap swiper-wrapper">
            {slider_images_vertical}
          </div>
          <div className="contacts-footer">
            <div className="contacts-pagination swiper-pagination"></div>
            <div className="contacts-nav-wrapper">
              <div className="swiper-button-next"></div>
              <div className="swiper-button-prev"></div>
            </div>
          </div>
        </div>
      );

    case 'text_image':
      return (
        <div className="course-descr">
          <div
            className="course-descr__image"
            style={{
              backgroundImage: `url('${block.content.group_content[0].image}')`,
            }}
          ></div>
          <div className="course-descr__info split-slider__banner">
            <img
              src={`/static/img/constructor/icons/white/${block.content.group_content[0].icon}.svg`}
            />
            <h4 className="heading heading--2">
              {block.content.group_content[0].title}
            </h4>
            <div
              className="course-descr__text txt--sm clean-html editor"
              dangerouslySetInnerHTML={{
                __html: block.content.group_content[0].text,
              }}
            />
          </div>
        </div>
      );

    case 'slider_content':
      const slider_content = block.content.slide_content.map((b, index) => {
        let link = null;
        if (b.link_text && b.link_url) {
          link = (
            <a className="btn btn--primary" href={b.link_url}>
              {b.link_text}
            </a>
          );
        }
        return (
          <div
            key={`${b.type}_${index}`}
            className="split-slider__item slider__item"
          >
            <div className="split-slider__banner">
              <img
                src={`/static/img/constructor/icons/white/${b.icon}.svg`}
              />
              <h3 className="heading heading--2">{b.title}</h3>
              <div
                className="txt clean-html editor"
                dangerouslySetInnerHTML={{
                  __html: b.text,
                }}
              />
              {link}
            </div>
            <div
              className="split-slider__img"
              style={{ backgroundImage: `url('${b.image}')` }}
            ></div>
          </div>
        );
      });

      return (
        <div className="simple-slider split-slider slider">
          <div className="slider__wrap">{slider_content}</div>
        </div>
      );

    case 'reviews':
      const reviews = block.content.group_reviews.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="slider__item review"
          >
            <div className="review__quote txt-accent">
              <span>{b.key_phrase}</span>
            </div>
            <div className="review__desrc">
              <p className="txt">{b.text}</p>
              <p className="review__name">{b.author}</p>
              <p className="review__post">{b.sign}</p>
            </div>
          </div>
        );
      });

      return (
        <div className="reviews-block">
          <h3 className="h1">Отзывы</h3>
          <div className="slider reviews__slider">
            <div className="slider__wrap reviews__wrap">{reviews}</div>
          </div>
        </div>
      );

    case 'slider_expert':
      const experts = block.content.slide_content.map((b, index) => {
        return (
          <div
            key={`${block.type}_${block.sort}_${index}`}
            className="key-expert-slide swiper-slide"
          >
            <div className="key-expert__top">
              {b.image ? (
                <div
                  className="key-expert__photo"
                  style={{ backgroundImage: 'url(' + b.image + ')' }}
                />
              ) : null}
              <div className="key-expert__info">
                <p className="key-expert__name">{b.expert_name}</p>
                <p className="key-expert__post">{b.expert_post}</p>
                <div
                  className="key-expert__descr clean-html editor"
                  dangerouslySetInnerHTML={{ __html: b.text }}
                />
              </div>
            </div>
          </div>
        );
      });

      return (
        <React.Fragment>
          <div className="key-expert-slider contacts-slider swiper-container">
            <div className="contacts-slider__wrap swiper-wrapper">
              {experts}
            </div>
            <div className="contacts-footer">
              <div className="contacts-pagination swiper-pagination"></div>
              <div className="contacts-nav-wrapper">
                <div className="swiper-button-next"></div>
                <div className="swiper-button-prev"></div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );

    default:
      return (
        <p className="txt txt--red">Неизвестный формат блока: {block.type}</p>
      );
    }
  }
}

export default wrapper(Block);
